<template>
  <div class="col-9 resultsection">
    <div class="d-flex justify-content-between">
      <span v-if="dataVesselShipment.length === 1"
        >Showing {{ dataVesselShipment.length }} Result</span
      >
      <span v-else>Showing {{ dataVesselShipment.length }} Results</span>
    </div>

    <SectionNotFound
      v-if="!dataVesselShipmentLength"
      description="No schedules found."
    />
    <div v-else>
      <!-- ============== Looping Result Searching (Cards) ============== -->
      <CardResult
        v-for="(data, idx) in dataVesselShipment"
        :key="idx"
        :data="data"
      />
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapGetters } from 'vuex'
import CardResult from './CardResult.vue'
import SectionNotFound from './SectionNotFound.vue'
export default {
  name: 'ResultSection',
  data () {
    return {
      sortDropdown: false
    }
  },
  props: {
    alternative: Boolean,
    dataVesselShipment: Array,
    dataVesselShipmentLength: Number
  },
  components: {
    CardResult,
    SectionNotFound
  },
  watch: {},
  computed: {},
  mounted () {},
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/vesselSchedule/ResultSection.vue